import { Container, Row, Col, Card, Button } from 'react-bootstrap';
import eventsData from '../data/events.json';
import { formatDate } from '../utils/dateFormat';
import { Link } from 'react-router-dom';

function Events() {
  return (
    <Container>
      <h1 className="mb-4 text-white">Upcoming Events</h1>
      <Row className="g-4">
        {eventsData.upcomingEvents.map((event) => (
          <Col key={event.id} md={6} lg={4}>
            <Card className="bg-dark text-white">
              {event.image && (
                <Card.Img 
                  variant="top" 
                  src={event.image} 
                  alt={event.title}
                  className="event-image"
                />
              )}
              <Card.Body>
                <Card.Title className="text-white">{event.title}</Card.Title>
                <Card.Subtitle className="mb-2 text-accent">
                  {formatDate(event.date)}{event.time ? ` at ${event.time}` : ''}
                </Card.Subtitle>
                <Card.Text className="text-white">
                  <strong>Location:</strong> {event.location}<br />
                  {event.description}
                </Card.Text>
                <div className="d-flex justify-content-end">
                  {event.ticketLink && (
                    <a 
                      href={event.ticketLink} 
                      className="btn btn-success w-auto"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Buy Tickets
                    </a>
                  )}
                </div>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <div className="mt-5">
        <h2 className="mb-4 text-white">Regular Rehearsals</h2>
        <Row>
          <Col>
            <Card className="bg-dark text-white">
              <Card.Body>
                <Card.Title className="text-white">Weekly Rehearsals</Card.Title>
                <Card.Subtitle className="mb-2 text-accent">Every Thursday</Card.Subtitle>
                <Card.Text className="text-white">
                  <strong>Time:</strong> 19:30 - 22:00<br />
                  <strong>Location:</strong> Trinity Walthamstow United Reformed Church, 58 Orford Rd, London E17 9QU
                </Card.Text>
                <p className="text-accent">
                  New members are always welcome. Please contact us on{' '}
                  <a href="mailto:eastlondonbrass@hotmail.com" className="text-accent">eastlondonbrass@hotmail.com</a>{' '}
                  if you'd like to join us for a rehearsal.
                </p>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
}

export default Events; 